import { fillString } from '@local_modules/generic/string-template.js'
import { generateString } from '@local_modules/flokit'
import '@local_modules/flokit/styles.css'
import { setElementHtml } from '../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 *
 * @returns
 */
export async function showAdminHome (params) {
  console.log('showAdminHome')
  console.log('params', params)

  const { containerElementId, browserAppUser } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Admin'].join(' ')
}
